import Loading from "@fuse/components/FuseLoadable/Loading";
import _ from "@lodash";
import withReducer from "app/store/withReducer";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import * as Actions from "./Store/Actions/DocumentoAtendimentoActions";
import DocumentoAtendimentoReducer from "./Store/Reducers/DocumentoAtendimentoReducer";

function DocumentoAtendimento(props) {

    const dispatch = useDispatch();
    const [showPreload, setShowPreload] = useState(true);
    const reducer = useSelector(({ DocumentoAtendimento }) => DocumentoAtendimento);

    window.changeFormulario = (_AValue) => {
        dispatch(Actions.get(_AValue, props));
    };

    window.addFile = () => {
        window.ArquivoOpenNew();
    };

    window.getNewToken = () => {
        dispatch(Actions.checkToken(props.xappRouteParams));
    };

    useEffect(() => dispatch(Actions.get("", props)), []);

    useEffect(() => {
        if (!_.isUndefined(reducer.data) && !_.isNull(reducer.data)) {
            setShowPreload(false);
        }
    }, [reducer]);

    useEffect(() => () => dispatch(Actions.clearReducer()), []);



    return (
        <React.Fragment>
            <div className="flex h-full">
                <iframe
                    id="iframe"
                    className={showPreload && "hidden"}
                    srcDoc={reducer.data}
                    title={"DocumentoAtendimento"}
                    width={"100%"}
                    height={"100%"}
                >
                </iframe>
                <div className={clsx("w-full items-center", showPreload ? "flex" : "hidden")}>
                    <Loading pastDelay={true} />
                </div>
            </div>
        </React.Fragment>
    );
}

export default withReducer("DocumentoAtendimento", DocumentoAtendimentoReducer)(withRouter(DocumentoAtendimento));